import { createSelector } from '@reduxjs/toolkit';
import { initialState } from '../models';
const selectDomain = (state) => state.home || initialState;

export const selectCategory = createSelector(
  [selectDomain],
  (home) => home.category
);
